export enum FiatWithdrawGatewayWithdrawStatus {
  QUEUED = 0,
  DONE = 1,
  FAILED = 2,
  CREATED = 3
}
